const generateHeliumWalletDeepLink = (payments: HeliumWalletPayment[]) => {
  const link = `https://wallet.helium.com/payment?payments=${encodeURIComponent(
    JSON.stringify(payments)
  )}`;

  window.open(link, "_blank");
};

export default generateHeliumWalletDeepLink;

//
// Utils
//

export interface HeliumWalletPayment {
  payee: string;
  amount: number;
  memo: string;
}
